// Indonesian formatting for dates, times, and rupiah.
const dateFmt = new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "short", year: "numeric" });
const timeFmt = new Intl.DateTimeFormat("id-ID", { hour: "2-digit", minute: "2-digit", hour12: false });
const rupiahFmt = new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 });

function parse(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** 30 Sep 2026 */
export function formatDate(iso: string | null | undefined): string {
  const d = parse(iso);
  return d ? dateFmt.format(d) : "Belum pernah";
}

/** 30 Sep 2026, 14.05 */
export function formatDateTime(iso: string | null | undefined): string {
  const d = parse(iso);
  return d ? `${dateFmt.format(d)}, ${timeFmt.format(d)}` : "Belum pernah";
}

/** Rp1.250.000.000 with a regular space after Rp. */
export function formatRupiah(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "Belum diisi";
  return rupiahFmt.format(value).replace(/ /g, " ");
}

/** A count with Indonesian thousands separators. */
export function formatCount(value: number): string {
  return new Intl.NumberFormat("id-ID").format(value);
}

/** "Rp 1.250.000" style typing aid: keeps digits only. */
export function digitsOnly(value: string): string {
  return value.replace(/[^\d]/g, "");
}

const rtf = new Intl.RelativeTimeFormat("id-ID", { numeric: "auto" });

/** "5 menit yang lalu", "kemarin", then the date after a week. */
export function formatRelative(iso: string | null | undefined, now: number = Date.now()): string {
  const d = parse(iso);
  if (!d) return "Belum pernah";
  const minutes = Math.round((d.getTime() - now) / 60_000);
  if (Math.abs(minutes) < 1) return "baru saja";
  if (Math.abs(minutes) < 60) return rtf.format(minutes, "minute");
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return rtf.format(hours, "hour");
  const days = Math.round(hours / 24);
  if (Math.abs(days) <= 7) return rtf.format(days, "day");
  return dateFmt.format(d);
}

/** "45 menit", "1 jam", "1 jam 20 menit"; null when the length is unknown. */
export function formatMinutes(minutes: number | null | undefined): string | null {
  if (minutes === null || minutes === undefined || !Number.isFinite(minutes) || minutes <= 0) return null;
  const m = Math.round(minutes);
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (h === 0) return `${rest} menit`;
  return rest === 0 ? `${h} jam` : `${h} jam ${rest} menit`;
}

const longDateFmt = new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "long", year: "numeric" });

/** 6 Oktober 2026 (certificates and other formal text). */
export function formatDateLong(iso: string | null | undefined): string {
  const d = parse(iso);
  return d ? longDateFmt.format(d) : "Belum pernah";
}
